import getEnvConfig from '@cld/env-config';

export const apiBaseUrl = getEnvConfig().apiBaseUrl;
export const sharedUrl = `${apiBaseUrl}/console/api/v1`;
export const publicBaseUrl = `${sharedUrl}/collections/public`;
